function Footer() {
    return (
        <footer className="bg-gray-800 text-white py-4">
            <div className="max-w-7xl mx-auto text-center">
                <p className="text-sm">© 2023 MySite. All rights reserved.</p>
                <div className="mt-2">
                    <a href="#" className="text-gray-400 hover:text-white mx-2">Privacy Policy</a>
                    <a href="#" className="text-gray-400 hover:text-white mx-2">Terms of Service</a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;